import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "../lib/api";

export default function DesignsGallery() {
  const [designs, setDesigns] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/designs").then((r) => { setDesigns(r.data); setLoaded(true); }).catch(() => setLoaded(true));
  }, []);

  return (
    <div className="p-10 max-w-6xl mx-auto">
      <p className="text-xs uppercase tracking-[0.25em] text-zinc-400">Team workspace</p>
      <h1 className="font-heading text-3xl font-bold mt-2 tracking-tight">Designs</h1>
      <p className="text-zinc-500 mt-2 text-sm">Every design and its full iteration history, shared with your team.</p>

      {loaded && designs.length === 0 && (
        <div className="mt-10 border-2 border-dashed border-zinc-200 rounded-lg p-16 text-center" data-testid="designs-empty-state">
          <p className="text-zinc-400 text-sm">No designs yet.</p>
          <Link to="/studio/sketch" className="mt-4 inline-block bg-zinc-950 text-white px-6 py-2.5 rounded-md text-sm font-medium hover:bg-zinc-800 transition-colors">Create your first render</Link>
        </div>
      )}

      <div className="mt-8 columns-2 md:columns-3 lg:columns-4 gap-4 [&>a]:mb-4">
        {designs.map((d) => (
          <Link key={d.id} to={`/designs/${d.id}`} data-testid={`design-card-${d.id}`}
            className="block break-inside-avoid border border-zinc-200 bg-white rounded-lg overflow-hidden hover:shadow-md transition-shadow group">
            <img src={imgUrl(d.cover_image)} alt={d.title} className="w-full object-cover group-hover:scale-[1.02] transition-transform duration-300" />
            <div className="p-3.5">
              <p className="text-sm font-medium truncate" data-testid={`design-card-title-${d.id}`}>{d.product_title || d.title}</p>
              {d.product_title && d.product_title !== d.title && <p className="text-[11px] text-zinc-400 truncate mt-0.5">{d.title}</p>}
              <p className="text-xs text-zinc-400 mt-0.5">{d.owner_name} · {d.versions.length} iteration{d.versions.length > 1 ? "s" : ""}</p>
              {d.product_description && (
                <p className="text-[11px] text-zinc-500 mt-2 line-clamp-3 whitespace-pre-line" data-testid={`design-description-preview-${d.id}`}>
                  {d.product_description}
                </p>
              )}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
